import { Stack } from '@mui/system';
import { white } from '@styles/colors';
import React, { FC, useState } from 'react';
import { useGetTemplateTagsList } from '../hooks/useGetTemplateTagsList';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import TagRow from '@features/employerAccount/components/TagRow/TagRow';
import CompaniesListWithPaymentSekelton from '@features/payments/components/PaymentCardDetail/CompaniesListWithPaymentSekelton';
import { Add } from '@mui/icons-material';
import AddNewTagModal from '@features/applications/components/AddNewTagModal/AddNewTagModal';
import { getCookie } from '@utils/getCookie';
import { EnterpriseTemplate } from '../types';
import ConfirmationModal from './ConfirmationModal';

type TemplateTagsManagementProps = {
  templateData: EnterpriseTemplate;
};

const TemplateTagsManagement: FC<TemplateTagsManagementProps> = ({
  templateData,
}) => {
  const dontShowWarningPopup = getCookie('dontShowWarningPopup');
  const isAppliedChanges = templateData.apply_changes && !dontShowWarningPopup;
  const [errorText, setErrorText] = useState('');
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const { tagsList, isLoadingTagsList } = useGetTemplateTagsList({
    enabled: true,
    setErrorText,
    templateId: templateData?.id,
  });
  const [showNewTag, setShowNewTag] = React.useState<boolean>(false);

  const handleAddNewTag = () => {
    if (isAppliedChanges) {
      setIsConfirmOpen(true);
    } else {
      setShowNewTag(true);
    }
  };
  const handleConfirm = () => {
    setShowNewTag(true);
    setIsConfirmOpen(false);
  };
  const handleCancel = () => {
    setIsConfirmOpen(false);
  };
  return (
    <Stack spacing={2}>
      <Button
        sx={{ width: 'fite-content', alignSelf: 'end' }}
        onClick={handleAddNewTag}
        variant="contained"
        color="success"
        startIcon={<Add />}
      >
        Add Tag
      </Button>
      <Stack spacing={3} bgcolor={white} p={3} borderRadius={8} width="100%">
        {isLoadingTagsList ? (
          <CompaniesListWithPaymentSekelton />
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Tag name</strong>
                </TableCell>
                <TableCell>
                  <strong>Action</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tagsList?.objects && tagsList.objects?.length > 0 ? (
                tagsList.objects.map(
                  (tag: {
                    id: number;
                    tag: string;
                    total_assigned_application: number;
                    predefined: number;
                  }) => (
                    <TagRow
                      key={tag.id}
                      tag={tag}
                      templateId={templateData?.id as number}
                      isAppliedChanges={isAppliedChanges}
                    />
                  ),
                )
              ) : (
                <TableRow hover>
                  <TableCell colSpan={6}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        alignSelf: 'center',
                        width: 'auto',
                        height: '300px',
                        margin: 'auto',
                      }}
                    >
                      FYI, default company tags are already assigned at the
                      company level. <br /> You can add additional company tags
                      to be copied to new locations using this template.
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
        {showNewTag && (
          <AddNewTagModal
            handleClose={() => setShowNewTag(false)}
            editable={null}
            templateId={templateData?.id as number}
          />
        )}
        <ConfirmationModal
          open={isConfirmOpen}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      </Stack>
    </Stack>
  );
};

export default TemplateTagsManagement;
